/* Diervital: default qty = 3 + dynamische 2+1 badge */
(function(){
  function clamp(val, min, max){
    if (isNaN(val)) val = min || 1;
    if (min != null && val < min) val = min;
    if (max != null && max !== '' && !isNaN(+max) && val > +max) val = +max;
    return val;
  }

  function setupInContainer(container){
    if (!container) return;

    // Quantity elementen vinden binnen dit productblok
    var qtyForm  = container.querySelector('.product-form__quantity');
    var qtyInput = container.querySelector('.product-form__quantity input.quantity__input');
    if (!qtyForm || !qtyInput) return;

    // Badge klaarzetten (1x)
    var badge = container.querySelector('.dv-offer-badge');
    if (!badge){
      badge = document.createElement('div');
      badge.className = 'dv-offer-badge';
      badge.setAttribute('aria-live','polite');
      qtyForm.parentNode.insertBefore(badge, qtyForm.nextSibling);
    }

    function getMin(){ return parseInt(qtyInput.getAttribute('data-min') || qtyInput.min || '1',10); }
    function getMax(){
      var a = qtyInput.getAttribute('data-max');
      return (a === null) ? null : parseInt(a,10);
    }
    function getQty(){ return parseInt(qtyInput.value || '1',10); }

    function setDefaultTo3(){
      var desired = clamp(3, getMin(), getMax());
      if (parseInt(qtyInput.value || '0',10) !== desired){
        qtyInput.value = desired;
        qtyInput.dispatchEvent(new Event('input',{bubbles:true}));
        qtyInput.dispatchEvent(new Event('change',{bubbles:true}));
      }
    }

    function updateBadge(q){
      var text = '';
      if (q === 3)      text = 'Jeej! Je profiteert van 2+1 GRATIS';
      else if (q === 2) text = 'Voeg je GRATIS pot toe en claim je aanbieding!';
      else if (q === 1) text = 'Voeg potten toe en profiteer van 2+1 GRATIS!';

      if (text){
        badge.style.display = 'inline-flex';
        badge.textContent = text; // veilig, geen HTML
      } else {
        badge.style.display = 'none';
      }
    }

    // Initialiseren
    setDefaultTo3();
    updateBadge(getQty());

    // Listeners
    qtyInput.addEventListener('input',  function(){ updateBadge(getQty()); }, {passive:true});
    qtyInput.addEventListener('change', function(){ updateBadge(getQty()); });

    var qtyWrapper = qtyForm.querySelector('quantity-input');
    if (qtyWrapper){
      qtyWrapper.addEventListener('click', function(){
        setTimeout(function(){ updateBadge(getQty()); }, 0);
      });
      qtyWrapper.addEventListener('quantity-update', function(){ updateBadge(getQty()); });
    }

    // Bij variantwissel (verschillende thema-events)
    document.addEventListener('variant:change',  function(){ setDefaultTo3(); updateBadge(getQty()); });
    document.addEventListener('variant:changed', function(){ setDefaultTo3(); updateBadge(getQty()); });

    // Fallback: als het thema DOM re-rendert zonder event, kijk met MutationObserver
    var mo = new MutationObserver(function(){
      var freshInput = container.querySelector('.product-form__quantity input.quantity__input');
      if (freshInput && freshInput !== qtyInput){
        qtyInput = freshInput;
        setDefaultTo3();
        updateBadge(getQty());
      }
    });
    mo.observe(container, {childList:true, subtree:true});
  }

  function init(){
    // Target elk product info blok (Dawn: id begint met ProductInfo-)
    document.querySelectorAll('[id^="ProductInfo-"]').forEach(setupInContainer);
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();